import { render, staticRenderFns } from "./TemplateSmsEdit.vue?vue&type=template&id=3c8bdfbf&"
import script from "./TemplateSmsEdit.vue?vue&type=script&lang=js&"
export * from "./TemplateSmsEdit.vue?vue&type=script&lang=js&"
import style0 from "./TemplateSmsEdit.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports